import { colorFromId, initialsFromName } from '@/lib/linear-utils';

interface Props {
  name?: string | null;
  color?: string | null;
  size?: number;
  className?: string;
}

export default function Avatar({ name, color, size = 18, className }: Props) {
  const label = name?.trim() || '?';
  const background = color || colorFromId(label);
  const fontSize = Math.max(8, Math.round(size * 0.42));

  return (
    <span
      className={className}
      title={label}
      style={{
        display: 'inline-flex',
        alignItems: 'center',
        justifyContent: 'center',
        width: size,
        height: size,
        borderRadius: '50%',
        background,
        color: '#fff',
        fontSize,
        fontWeight: 590,
        lineHeight: 1,
        flexShrink: 0,
        letterSpacing: '-0.02em',
      }}
      aria-label={label}
    >
      {initialsFromName(label)}
    </span>
  );
}
